module.exports = __webpack_public_path__ + "img/art_passing_by.f8bfb3e2.jpg";